import React, { useState } from 'react';
import VCFirmsTab from './VCFirmsTab';
import VCPortfolioTab from './VCPortfolioTab';

const VCTabsSection = () => {
    const [activeTab, setActiveTab] = useState('vc');

    return (
        <>
            <div className="lp-vc-tabbar">
                <div className="lp-vc-tabbar-inner" role="tablist">
                    <button className={`lp-vc-tab ${activeTab === 'vc' ? 'is-active' : ''}`} role="tab" aria-selected={activeTab === 'vc'} onClick={() => setActiveTab('vc')}>For VC firms</button>
                    <button className={`lp-vc-tab ${activeTab === 'portfolio' ? 'is-active' : ''}`} role="tab" aria-selected={activeTab === 'portfolio'} onClick={() => setActiveTab('portfolio')}>For portfolio companies</button>
                </div>
            </div>

            <div id="tab-content">
                <div style={{ display: activeTab === 'vc' ? 'block' : 'none' }}><VCFirmsTab /></div>
                <div style={{ display: activeTab === 'portfolio' ? 'block' : 'none' }}><VCPortfolioTab /></div>
            </div>
        </>
    );
};

export default VCTabsSection;
